import { z } from 'zod';

/**
 * События, которые Mini App может записать сам (POST /analytics/event). Белый список:
 * всё остальное пишет сервер по своим фактам (track.ts). Расширяется только добавлением
 * варианта в union — произвольный event или лишние props отсекает схема.
 */
export const clientEventSchema = z.discriminatedUnion('event', [
  z
    .object({
      event: z.literal('onboarding_cta'),
      props: z.object({ action: z.enum(['create', 'skip']) }).strict(),
    })
    .strict(),
]);

export type ClientEventInput = z.infer<typeof clientEventSchema>;

export const CLIENT_EVENTS = clientEventSchema.options.map((o) => o.shape.event.value);
